import type { FaturaPainel, FaixaAging } from './types.ts';
import { valorDevido } from '../statusBoleto.ts';
import { faturasDoPainel } from './definicoesKpi.ts';

function paraDataLocalSemHora(valor: string): Date {
  const [ano, mes, dia] = valor.split('T')[0].split('-').map(Number);
  return new Date(ano, (mes || 1) - 1, dia || 1);
}

const ORDEM_FAIXAS: FaixaAging['faixa'][] = ['A vencer', '1–7', '8–15', '16–30', '31–60', '61–90', '+90'];

function faixaPorDiasAtraso(dias: number): FaixaAging['faixa'] {
  if (dias <= 7) return '1–7';
  if (dias <= 15) return '8–15';
  if (dias <= 30) return '16–30';
  if (dias <= 60) return '31–60';
  if (dias <= 90) return '61–90';
  return '+90';
}

// Tabela de aging da spec (seção 10): "A vencer" agrega os Em aberto; as
// demais 6 faixas classificam os Vencido pelos dias de atraso (hoje - vencimento).
export function calcularAging(entrada: FaturaPainel[], hoje: Date): FaixaAging[] {
  // Mesmo recorte dos KPIs: conta interna fora (solicitação 5955).
  const dados = faturasDoPainel(entrada);
  const acumulador = new Map<FaixaAging['faixa'], { qtde: number; valor: number }>(
    ORDEM_FAIXAS.map((f) => [f, { qtde: 0, valor: 0 }])
  );
  const hojeSemHora = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());

  dados.forEach((f) => {
    const valor = valorDevido(f);
    if (f.statusDerivado === 'Em aberto') {
      const acc = acumulador.get('A vencer')!;
      acc.qtde += 1;
      acc.valor += valor;
      return;
    }
    if (f.statusDerivado !== 'Vencido') return;

    const vencStr = f.vencimento_boleto || f.data_vencimento;
    if (!vencStr) return;
    const dias = Math.round((hojeSemHora.getTime() - paraDataLocalSemHora(vencStr).getTime()) / 86400000);
    const faixa = faixaPorDiasAtraso(Math.max(dias, 1));
    const acc = acumulador.get(faixa)!;
    acc.qtde += 1;
    acc.valor += valor;
  });

  return ORDEM_FAIXAS.map((faixa) => ({ faixa, ...acumulador.get(faixa)! }));
}
